import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker } from "@/hooks/usePushNotifications";

// Register service worker (PWA + push notifications)
if (typeof window !== "undefined") {
  window.addEventListener("load", () => { registerServiceWorker(); });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
